import React, {ReactNode} from 'react';

export type BooleanInputProps = Omit<React.ComponentProps<'input'>, 'type' | 'value' | 'children'> & {
    inputRef?: React.Ref<HTMLInputElement>;
};

export type IconProp = {element: React.JSX.Element} | {src: string; element?: never};
export const IconProp = {
    render: (prop: IconProp): ReactNode => {
        if ('element' in prop) {
            return prop.element;
        } else {
            return React.createElement('img', {src: prop.src, width: '100%', height: '100%'});
        }
    },
};
